import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=267a8eb9"
import script from "./NewsComponent.vue?vue&type=script&lang=ts"
export * from "./NewsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports